import { DialogContentText, Stack } from "@mui/material"
import { ReactElement } from "react"
import { useNavigate } from "react-router-dom"

import { NETWORK_TO_DNO_FRIENDLY_ABBREVIATION_DISPATCHER } from "../../../constants/dnos"
import { INSTALLER_SINGLE_APPLICATION_BASE } from "../../../router/routes"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"
import { getValue } from "../../../utils/general/generalUtils"
import { ApprovalsIcon } from "../../icons/icons"
import SuccessConfirmationTemplate from "../../popUps/success/successConfirmationTemplate"
import { AppCard } from "../../surfaces/appCard"

const approve = (props: any): ReactElement => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <ApprovalsIcon color="success" {...props} />
)

interface ISubmitCxSuccessProps {
    isOpen: boolean
    dno: string
    applicationId: string
}

const SubmitCxSuccess = ({
    isOpen,
    dno,
    applicationId,
}: ISubmitCxSuccessProps): ReactElement => {
    const navigate = useNavigate()

    const dnoDisplayName =
        getValue(NETWORK_TO_DNO_FRIENDLY_ABBREVIATION_DISPATCHER, dno) ?? dno

    return (
        <SuccessConfirmationTemplate
            title="Commissioning Successfully Submitted!"
            subtitle={`Your commissioning information has been passed to ${dnoDisplayName} for review`}
            nextButtonTitle="Click to view the application"
            onClickNext={() =>
                navigate(
                    `${INSTALLER_SINGLE_APPLICATION_BASE}/${applicationId}`
                )
            }
            isOpen={isOpen}
            successId={applicationId}
            successIdName="ID"
            color="primary"
            icon={approve}
        >
            <Stack spacing={GRID_SPACING}>
                <AppCard
                    sx={{
                        backgroundColor: "background.contentBackground",
                    }}
                >
                    <DialogContentText
                        fontWeight={800}
                        fontSize="body1.fontSize"
                    >
                        What happens next?
                    </DialogContentText>
                    <DialogContentText fontSize="body1.fontSize">
                        Your commissioning information has been sent to{" "}
                        {dnoDisplayName}. They will either accept it or request
                        further information. Both outcomes will be communicated
                        to you on here. Should they provide further information,
                        you will be able to resubmit it on here too!
                        <br />
                        <br />
                        Once your commissioning is approved, {
                            dnoDisplayName
                        }{" "}
                        could provide an export MPAN (if required) complete the
                        process.
                    </DialogContentText>
                </AppCard>
            </Stack>
        </SuccessConfirmationTemplate>
    )
}

export default SubmitCxSuccess
